import info from "../../info.jsonc";
const description = info.description;
const skills: string[] = info.skills;
const experience: { role: string; company: string; period: string; description: string }[] = info.experience;

export function About() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 md:px-6">
      <h1 className="text-3xl md:text-4xl font-bold mb-8">About Me</h1>

      <div className="space-y-8">
        <section>
          <p className="text-lg text-zinc-300 leading-relaxed">
            {description}
          </p>
        </section>

        {skills.length > 0 ? (
          <section>
            <h2 className="text-2xl font-semibold mb-4 ">Skills</h2>
            <div className="flex flex-wrap gap-3">
              {skills.map((skill) => (
                <span
                  key={skill}
                  className="px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-300"
                >
                  {skill}
                </span>
              ))}
            </div>
          </section>
        ) : null}
        {experience.length > 0 ? (
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">Experience</h2>
            <div className="space-y-6">
              {experience.map((exp, i) => (
                <div key={i} className="border-l-2 border-cyan-500 pl-4">
                  <h3 className="text-lg font-medium">{exp.role}</h3>
                  <p className="text-zinc-400">{exp.company} · {exp.period}</p>
                  <p className="text-zinc-400 mt-1">{exp.description}</p>
                </div>
              ))}
            </div>
          </section>
        ) : null}
      </div>
    </div>
  );
}
